import React, { useState, useEffect } from 'react';
import { DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

const TeamForm = ({ team, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    department: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (team) {
      setFormData({
        name: team.name || '',
        department: team.department || '',
      });
    } else {
      setFormData({ name: '', department: '' });
    }
  }, [team]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    await onSave(formData);
    setIsLoading(false);
  };

  return (
    <DialogContent className="sm:max-w-[480px] bg-slate-800 border-slate-700 text-slate-100">
      <DialogHeader>
        <DialogTitle className="text-2xl text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-500">
          {team ? 'Edit Team' : 'Create New Team'}
        </DialogTitle>
        <DialogDescription className="text-slate-400">
          {team ? 'Update the details for this team.' : 'Fill in the details to create a new team.'}
        </DialogDescription>
      </DialogHeader>
      <form onSubmit={handleSubmit} className="space-y-6 py-4">
        <div>
          <Label htmlFor="name" className="text-slate-300">Team Name</Label>
          <Input id="name" name="name" value={formData.name} onChange={handleChange} required className="mt-1" />
        </div>
        <div>
          <Label htmlFor="department" className="text-slate-300">Department (Optional)</Label>
          <Input id="department" name="department" value={formData.department} onChange={handleChange} className="mt-1" />
        </div>
        <DialogFooter className="pt-4">
          <Button type="button" variant="outline" onClick={onCancel} disabled={isLoading} className="text-slate-300 border-slate-600 hover:bg-slate-700 hover:text-slate-100">
            Cancel
          </Button>
          <Button type="submit" disabled={isLoading} className="bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 text-white">
            {isLoading ? (team ? 'Saving...' : 'Creating...') : (team ? 'Save Changes' : 'Create Team')}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  );
};

export default TeamForm;